import { Locale } from '@ps-smart-cp/ppfw-client';

const increDecreBookValSetNameConfig = {
  beginTerm: new Map([
    [Locale.ja, '期首'],
    [Locale.en, 'Begin Term'],
  ]),

  beginTermEndFirstHalf: new Map([
    [Locale.ja, '期首上期末'],
    [Locale.en, 'Begin Term End First Half'],
  ]),

  endQuarter: new Map([
    [Locale.ja, '四半期末'],
    [Locale.en, 'End Quarter'],
  ]),

  endPreviousMonth: new Map([
    [Locale.ja, '前月末'],
    [Locale.en, 'End Previous Month'],
  ]),

  endMonth: new Map([
    [Locale.ja, '当月末'],
    [Locale.en, 'End Month'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { increDecreBookValSetNameConfig };
